import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    Load: IProjectItemImportLoadByIdActionCreator = (id, trialId) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_LOAD_BY_ID,
            id,
            trialId
        }
    },
    LoadSuccess: IProjectItemImportLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectItemImportLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_LOAD_FAILURE,
            responseStatus
        }
    },
    Save: IProjectItemImportSaveActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_SAVE,
            formData
        }
    },
    SaveSuccess: IProjectItemImportSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IProjectItemImportSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_SAVE_FAILURE,
            responseStatus
        }
    },
    Clear: IProjectItemImportClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_CLEAR,
            propertiesToClear
        }
    },
    Filter: IProjectItemImportFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PROJECTITEMIMPORT_FILTER,
            formFilter
        }
    };

export const
    ACTION_PROJECTITEMIMPORT_LOAD_BY_ID = "ACTION_PROJECTITEMIMPORT_LOAD_BY_ID",
    ACTION_PROJECTITEMIMPORT_LOAD_SUCCESS = "ACTION_PROJECTITEMIMPORT_LOAD_SUCCESS",
    ACTION_PROJECTITEMIMPORT_LOAD_FAILURE = "ACTION_PROJECTITEMIMPORT_LOAD_FAILURE",

    ACTION_PROJECTITEMIMPORT_SAVE = "ACTION_PROJECTITEMIMPORT_SAVE",
    ACTION_PROJECTITEMIMPORT_SAVE_SUCCESS = "ACTION_PROJECTITEMIMPORT_SAVE_SUCCESS",
    ACTION_PROJECTITEMIMPORT_SAVE_FAILURE = "ACTION_PROJECTITEMIMPORT_SAVE_FAILURE",

    ACTION_PROJECTITEMIMPORT_CLEAR = "ACTION_PROJECTITEMIMPORT_CLEAR",

    ACTION_PROJECTITEMIMPORT_FILTER = "ACTION_PROJECTITEMIMPORT_FILTER";

export interface IProjectItemImportLoadAction {
    type: "ACTION_PROJECTITEMIMPORT_LOAD";
}

export interface IProjectItemImportLoadActionCreator {
    (): IProjectItemImportLoadAction;
}

export interface IProjectItemImportLoadSuccessAction {
    type: "ACTION_PROJECTITEMIMPORT_LOAD_SUCCESS";
    formData: Dtos.ProjectItemImport;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemImportLoadSuccessActionCreator {
    (
        formData: Dtos.ProjectItemImport,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemImportLoadSuccessAction;
}

export interface IProjectItemImportLoadFailureAction {
    type: "ACTION_PROJECTITEMIMPORT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemImportLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemImportLoadFailureAction;
}

export interface IProjectItemImportLoadByIdAction {
    type: "ACTION_PROJECTITEMIMPORT_LOAD_BY_ID";
    id: number;
    trialId: number;
}

export interface IProjectItemImportLoadByIdActionCreator {
    (id: number, trialId: number): IProjectItemImportLoadByIdAction;
}

export interface IProjectItemImportSaveAction {
    type: "ACTION_PROJECTITEMIMPORT_SAVE";
    formData: Dtos.ProjectItemImport;

}

export interface IProjectItemImportSaveActionCreator {
    (
        formData: Dtos.ProjectItemImport
    ): IProjectItemImportSaveAction;
}

export interface IProjectItemImportSaveSuccessAction {
    type: "ACTION_PROJECTITEMIMPORT_SAVE_SUCCESS";
    formData: Dtos.ProjectItemImport;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemImportSaveSuccessActionCreator {
    (
        formData: Dtos.ProjectItemImport,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemImportSaveSuccessAction;
}

export interface IProjectItemImportSaveFailureAction {
    type: "ACTION_PROJECTITEMIMPORT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemImportSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemImportSaveFailureAction;
}

export interface IProjectItemImportClearAction {
    type: "ACTION_PROJECTITEMIMPORT_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectItemImportClearActionCreator {
    (propertiesToClear?: string[]): IProjectItemImportClearAction;
}

export interface IProjectItemImportFilterActionCreator {
    (formFilter: IFormFilter): IProjectItemImportFilterAction;
}

export interface IProjectItemImportFilterAction {
    type: "ACTION_PROJECTITEMIMPORT_FILTER";
    formFilter: IFormFilter;
}

export type ProjectItemImportAction =
    IProjectItemImportLoadByIdAction |
    IProjectItemImportLoadFailureAction |
    IProjectItemImportLoadSuccessAction |
    IProjectItemImportSaveAction |
    IProjectItemImportSaveSuccessAction |
    IProjectItemImportSaveFailureAction |
    IProjectItemImportClearAction |
    IProjectItemImportFilterAction;
